import api from './api';

/**
 * Helper to download a blob as a file
 */
const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Export tailored resume as PDF
 */
export const exportResumePDF = async (tailoredResumeId, filename = 'resume.pdf') => {
  const response = await api.post(
    '/exports/resume',
    { tailoredResumeId },
    { responseType: 'blob' }
  );

  downloadBlob(response.data, filename);
  return true;
};

/**
 * Export cover letter as PDF
 */
export const exportCoverLetterPDF = async (tailoredResumeId, filename = 'cover-letter.pdf') => {
  const response = await api.post(
    '/exports/cover-letter',
    { tailoredResumeId },
    { responseType: 'blob' }
  );

  downloadBlob(response.data, filename);
  return true;
};

/**
 * Export original (untailored) resume as PDF
 */
export const exportOriginalResumePDF = async (resumeId, filename = 'resume.pdf') => {
  const response = await api.post(
    '/exports/original-resume',
    { resumeId },
    { responseType: 'blob' }
  );

  downloadBlob(response.data, filename);
  return true;
};

export default {
  exportResumePDF,
  exportCoverLetterPDF,
  exportOriginalResumePDF
};
